import WebsitePageGroup from "../../../components/AssetManagement/Website/PageGroups/WebsitePageGroup";

function WebsitePageGroupScreen(userToken: any) {
  return (
    <>
      <WebsitePageGroup userToken={userToken} />
    </>
  );
}

export default WebsitePageGroupScreen;
